import React, { Component } from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import { delay } from '../../HOME/utils';
import { YELLOW, YOUTUBE } from '../../HOME/const';
import { YOUTUBE_MT } from '../const';
import { showHelp } from '../REDUX/actions';
import ContactButton from '../../HOME/COMPONENTS/ContactButton';

class Help extends Component {
  state = {};

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  dismiss = () => {
    this.setState({ closing: true });

    delay(() => {
      if (this.mounted) {
        this.setState({ closing: false }, () => this.props.showHelp(false));
      }
    });
  };

  render() {
    const cls = `tt-help ${this.state.closing ? 'fadeout' : 'fadein-fast'}`;
    const color = YELLOW;

    return (
      <div className={cls} style={{ grid: 'auto 10px auto 10px auto 5px auto/auto 1fr' }}>
        <Bullet row="1" />
        <span style={{ gridArea: '1/2', overflow: 'auto' }}>
          Your goal is to discover all the stars hidden in the grid in as little time as possible. Try to memorize the stars' positions as you
          find them.
        </span>
        <Bullet row="3" />
        <span style={{ gridArea: '3/2', overflow: 'auto' }}>
          Tap the cell where you think a star may be hidden. If you guess wrong, <span style={{ color }}>some or all</span> of the previously
          discovered stars <span style={{ color }}>disappear</span> and you have to "re-discover" them.
        </span>
        <Bullet row="5" />
        <span style={{ gridArea: '5/2', overflow: 'auto' }}>
          Your <span style={{ color }}>grade</span> is based on your average score and the number of games played. Play{' '}
          <span style={{ color }}>ten times</span> or more to get full credit.
        </span>
        <div className="ms-start" style={{ gridArea: '7/1/auto/span 2', border: 'initial', margin: 0, color: 'orange' }} onClick={this.dismiss}>
          OK
        </div>
        <ContactButton size={36} service={YOUTUBE} url={YOUTUBE_MT} style={{ gridArea: '7/2', justifySelf: 'end' }} />
      </div>
    );
  }
}

function mapStateToProps({ tt, common }) {
  return { ...tt, ...common };
}

export default connect(
  mapStateToProps,
  { showHelp }
)(Help);

const Bullet = props => {
  const area = `${props.row}/1`;
  const color = YELLOW;
  return <span style={{ gridArea: area, marginRight: '10px', color }}>•</span>;
};
